import React from "react";
import Switch from "react-switch";
import TimePicker from "react-datepicker";
import { SwitchCauHinhTatToan } from "../CauHinhHeThong/CauHinhTatToan/SwitchCauHinhTatToan";
import NumberFormat from "react-number-format";

export const FormCauHinhHeThong = ({
  data,
  handleInputChange,
  CustomRadio,
  handleTimeChange,
  handleTatToanChange,
  isPhatChamVisible,
}) => {
  const isCauHinhT77 =
    data.isCauHinhT77 === 1 ||
    data.isCauHinhT77 === "1" ||
    data.isCauHinhT77 === true;

  const isUseChuKySo =
    data.isCauHinhChuKySo === 1 ||
    data.isCauHinhChuKySo === "1" ||
    data.isCauHinhChuKySo === true;

  const isXuatHoaDon =
    data.isXuatHoaDon === 1 ||
    data.isXuatHoaDon === "1" ||
    data.isXuatHoaDon === true;

  return (
    <div style={{ overflowX: "auto", width: "100%", paddingBottom: "10px" }}>
      <div
        className="form-body custom-form-layout"
        style={{ minWidth: "900px" }}
      >
        <div className="form-group row">
          <label className="col-md-2 label-control">
            Sử dụng đăng nhập bằng sms
          </label>
          <div className="col-md-10">
            <Switch
              onChange={(checked) =>
                handleInputChange({
                  target: { name: "IsSendLoginSMS", checked, type: "checkbox" },
                })
              }
              checked={data.IsSendLoginSMS}
              onColor="#28D094"
              offColor="#d9534f"
              height={24}
              width={50}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-md-2 label-control">Sử dụng dịch vụ sms</label>
          <div className="col-md-10">
            <div className="d-flex align-items-center">
              {CustomRadio && (
                <CustomRadio
                  id="smsKoDung"
                  name="SendSmsType"
                  value={0}
                  dataType="number"
                  checked={data.SendSmsType === 0}
                  onChange={handleInputChange}
                  label="Không dùng"
                  className="mb-0 mr-3"
                />
              )}
              {CustomRadio && (
                <CustomRadio
                  id="smsBrandName"
                  name="SendSmsType"
                  value={2}
                  dataType="number"
                  checked={data.SendSmsType === 2}
                  onChange={handleInputChange}
                  label="Brand Name"
                  className="mb-0"
                />
              )}
            </div>
          </div>
        </div>

        <div className="form-group row">
          <label className="col-md-2 label-control">
            Cấu hình gửi tin nhắn tự động
          </label>
          <div className="col-md-10 align-items-start">
            <Switch
              onChange={(checked) =>
                handleInputChange({
                  target: { name: "AutoSms", checked, type: "checkbox" },
                })
              }
              checked={data.AutoSms}
              onColor="#28D094"
              offColor="#d9534f"
              height={24}
              width={50}
            />
            <div
              className="d-flex align-items-center ms-3"
              style={{ visibility: data.AutoSms ? "visible" : "hidden" }}
            >
              <span>Gửi trước ngày đóng lãi, thanh toán, tất toán</span>
              <input
                type="text"
                name="DaySms"
                value={data.DaySms}
                onChange={handleInputChange}
                className="form-control input-sm mx-1"
                style={{ width: "60px" }}
                data-type="number"
              />
              <span>Ngày</span>
              <div
                style={{
                  borderLeft: "2px solid gray",
                  height: "24px",
                  margin: "0 12px",
                }}
              ></div>
              <span>Giờ gửi</span>
              <TimePicker
                selected={data.TimeSms}
                onChange={handleTimeChange}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={1}
                timeCaption="Giờ gửi"
                dateFormat="HH:mm"
                className="form-control input-sm"
                wrapperClassName="time-picker-wrapper"
                popperClassName="morman-datepicker-theme"
                popperModifiers={{
                  offset: {
                    enabled: true,
                    offset: "13, 0",
                  },
                }}
              />
            </div>
          </div>
        </div>
        <div className="form-group row">
          <label className="col-md-2 label-control">Cấu hình trả góp</label>
          <div className="col-md-10">
            <Switch
              onChange={(checked) => {
                const value = checked ? 1 : 0;
                handleInputChange({
                  target: {
                    name: "LaiBatHo",
                    value: value,
                    type: "radio",
                    dataset: { type: "number" },
                  },
                });
              }}
              checked={data.LaiBatHo === 1}
              onColor="#28D094"
              offColor="#d9534f"
              height={24}
              width={50}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-md-2 label-control">
            Phân quyền theo chức vụ
          </label>
          <div className="col-md-10">
            <Switch
              onChange={(checked) => {
                const value = checked ? 1 : 0;
                handleInputChange({
                  target: {
                    name: "PhanQuyenTheoViTri",
                    value: value,
                    type: "radio",
                    dataset: { type: "number" },
                  },
                });
              }}
              checked={data.PhanQuyenTheoViTri === 1}
              onColor="#28D094"
              offColor="#d9534f"
              height={24}
              width={50}
            />
          </div>
        </div>
        {isCauHinhT77 && (
          <div className="form-group row">
            <label className="col-md-2 label-control">
              Dư nợ giảm dần (Gốc cố định - Lãi giảm dần)
            </label>
            <div className="col-md-10">
              <Switch
                onChange={(checked) => {
                  const value = checked ? 1 : 0;
                  handleInputChange({
                    target: {
                      name: "DuNoGiamDanLaiGiamDan",
                      value: value,
                      type: "radio",
                      dataset: { type: "number" },
                    },
                  });
                }}
                checked={data.DuNoGiamDanLaiGiamDan === 1}
                onColor="#28D094"
                offColor="#d9534f"
                height={24}
                width={50}
              />
            </div>
          </div>
        )}
        <div className="form-group row">
          <label className="col-md-2 label-control">
            Sử dụng hoa hồng trả góp
          </label>
          <div className="col-md-10">
            <Switch
              onChange={(checked) => {
                const value = checked ? 1 : 0;
                handleInputChange({
                  target: {
                    name: "HoaHongTraGop",
                    value: value,
                    type: "radio",
                    dataset: { type: "number" },
                  },
                });
              }}
              checked={data.HoaHongTraGop === 1}
              onColor="#28D094"
              offColor="#d9534f"
              height={24}
              width={50}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-md-2 label-control">
            Sử dụng danh sách nợ xấu
          </label>
          <div className="col-md-10">
            <Switch
              onChange={(checked) => {
                const value = checked ? 1 : 0;
                handleInputChange({
                  target: {
                    name: "SuDungTachNoXau",
                    value: value,
                    type: "radio",
                    dataset: { type: "number" },
                  },
                });
              }}
              checked={data.SuDungTachNoXau === 1}
              onColor="#28D094"
              offColor="#d9534f"
              height={24}
              width={50}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-md-2 label-control">Cấu hình ngôn ngữ</label>
          <div className="col-md-10">
            {CustomRadio && (
              <CustomRadio
                id="langVI"
                name="Language"
                value={0}
                dataType="number"
                checked={data.Language === 0}
                onChange={handleInputChange}
                label="Tiếng Việt"
                className="mb-0 mr-3"
              />
            )}
            {CustomRadio && (
              <CustomRadio
                id="langVI"
                name="Language"
                value={0}
                dataType="number"
                checked={data.Language === 0}
                onChange={handleInputChange}
                label="Tiếng Việt"
                className="mb-0 mr-3"
              />
            )}
          </div>
        </div>
        {isUseChuKySo && (
          <div className="form-group row">
            <label className="col-md-2 label-control">Cấu hình chữ ký số</label>
            <div className="col-md-10">
              {CustomRadio && (
                <CustomRadio
                  id="usbToken"
                  name="ChuKySo"
                  value={1}
                  dataType="number"
                  checked={data.ChuKySo === 1}
                  onChange={handleInputChange}
                  label="USB Token"
                  className="mb-0"
                />
              )}
              {CustomRadio && (
                <CustomRadio
                  id="bt3"
                  name="ChuKySo"
                  value={2}
                  dataType="number"
                  checked={data.ChuKySo === 2}
                  onChange={handleInputChange}
                  label="Tích hợp bên thứ 3 (VNPT, Viettel..)(chưa hỗ trợ)"
                  className="mb-0"
                />
              )}
            </div>
          </div>
        )}
        <div className="form-group row">
          <label className="col-md-2 label-control">Cấu hình nợ phải thu</label>
          <div className="col-md-10 d-flex align-items-center">
            <input
              type="number"
              name="CauHinhNgayNoPhaiThu"
              value={data.CauHinhNgayNoPhaiThu}
              onChange={handleInputChange}
              className="form-control input-sm"
              style={{ width: "100px" }}
              data-type="number"
            />
            <span className="ms-1 ml-1">Ngày</span>
          </div>
        </div>
        {data.IsTrichLapDuPhong === 1 && (
          <>
            <div className="form-group row">
              <label className="col-md-2 label-control">Nợ chú ý</label>
              <div className="col-md-10 d-flex align-items-center">
                <input
                  type="number"
                  name="CauHinhNgayNoChuY"
                  value={data.CauHinhNgayNoChuY}
                  onChange={handleInputChange}
                  className="form-control input-sm"
                  style={{ width: "100px" }}
                  data-type="number"
                />
                <span className="ms-1 ml-1">Ngày</span>
              </div>
            </div>
            <div className="form-group row">
              <label className="col-md-2 label-control">Nợ xấu</label>
              <div className="col-md-10 d-flex align-items-center">
                <input
                  type="number"
                  name="CauHinhNgayNoXau"
                  value={data.CauHinhNgayNoXau}
                  onChange={handleInputChange}
                  className="form-control input-sm"
                  style={{ width: "100px" }}
                  data-type="number"
                />
                <span className="ms-1 ml-1">Ngày</span>
              </div>
            </div>
            <div className="form-group row">
              <label className="col-md-2 label-control">Nợ rủi ro</label>
              <div className="col-md-10 d-flex align-items-center">
                <input
                  type="number"
                  name="CauHinhNgayNoRuiRo"
                  value={data.CauHinhNgayNoRuiRo}
                  onChange={handleInputChange}
                  className="form-control input-sm"
                  style={{ width: "100px" }}
                  data-type="number"
                />
                <span className="ms-1 ml-1">Ngày</span>
              </div>
            </div>
            <div className="form-group row">
              <label className="col-md-2 label-control">Nợ quá hạn</label>
              <div className="col-md-10 d-flex align-items-center">
                <input
                  type="number"
                  name="CauHinhNgayNoQuaHan"
                  value={data.CauHinhNgayNoQuaHan}
                  onChange={handleInputChange}
                  className="form-control input-sm"
                  style={{ width: "100px" }}
                  data-type="number"
                />
                <span className="ms-1 ml-1">Ngày</span>
              </div>
            </div>
          </>
        )}
        {data.Debtstatus_auto3_npt === 1 && (
          <>
            <div className="form-group row">
              <label className="col-md-2 label-control">Nợ xấu</label>
              <div className="col-md-10 d-flex align-items-center">
                <input
                  type="number"
                  name="CauHinhNgayNoXau"
                  value={data.CauHinhNgayNoXau}
                  onChange={handleInputChange}
                  className="form-control input-sm"
                  style={{ width: "100px" }}
                  data-type="number"
                />
                <span className="ms-1 ml-1">Ngày</span>
              </div>
            </div>
            <div className="form-group row">
              <label className="col-md-2 label-control">Nợ rủi ro</label>
              <div className="col-md-10 d-flex align-items-center">
                <input
                  type="number"
                  name="CauHinhNgayNoRuiRo"
                  value={data.CauHinhNgayNoRuiRo}
                  onChange={handleInputChange}
                  className="form-control input-sm"
                  style={{ width: "100px" }}
                  data-type="number"
                />
                <span className="ms-1 ml-1">Ngày</span>
              </div>
            </div>
          </>
        )}
        {isPhatChamVisible && (
          <div className="form-group row">
            <label className="col-md-2 label-control">Phạt chậm tối đa</label>
            <div className="col-md-10 d-flex align-items-center">
              <div className="mr-1 mt-0">
                {" "}
                <Switch
                  onChange={(checked) => {
                    const value = checked ? 1 : 0;
                    handleInputChange({
                      target: {
                        name: "UseCauHinhPhatChamToiDa",
                        value: value,
                        type: "radio",
                        dataset: { type: "number" },
                      },
                    });
                  }}
                  checked={data.UseCauHinhPhatChamToiDa === 1}
                  onColor="#28D094"
                  offColor="#d9534f"
                  height={24}
                  width={50}
                />
              </div>
              <div
                className="d-flex align-items-center ms-2"
                style={{
                  visibility:
                    data.UseCauHinhPhatChamToiDa === 1 ? "visible" : "hidden",
                }}
              >
                <input
                  type="text"
                  name="CauHinhPhatChamToiDa"
                  value={data.CauHinhPhatChamToiDa}
                  onChange={handleInputChange}
                  className="form-control input-sm"
                  style={{ width: "80px" }}
                />
                <span className="ml-1">%</span>
              </div>
            </div>
          </div>
        )}
        {isXuatHoaDon && (
          <div className="form-group row">
            <label className="col-md-2 label-control">Tỷ lệ phí xuất</label>
            <div className="col-md-10 d-flex align-items-center">
              <NumberFormat
                value={data.TyLePhiXuat}
                decimalSeparator="."
                allowNegative={false}
                className="form-control input-sm"
                style={{ width: "100px" }}
                onValueChange={(values) => {
                  handleInputChange({
                    target: {
                      name: "TyLePhiXuat",
                      value: values.value,
                      dataset: { type: "number" },
                    },
                  });
                }}
              />
              <span className="ms-2 ml-2 color7" style={{ fontSize: "12px" }}>
                Tỷ lệ tính phí cho phiếu thu khi xuất hóa đơn
              </span>
            </div>
          </div>
        )}
        {data.HeThongSuDungCauHinhTatToan === 1 && (
          <div className="form-group row">
            <label className="col-md-2 label-control">Cấu hình tất toán</label>
            <div className="col-md-10 d-flex align-items-center">
              <SwitchCauHinhTatToan
                checked={data.CauHinhTatToan === 1}
                onChange={handleTatToanChange}
              />
              <div
                className="ms-3 mt-2 p-2"
                style={{
                  visibility: data.CauHinhTatToan ? "visible" : "hidden",
                }}
              >
                <div className="d-flex align-items-center mb-2">
                  {CustomRadio && (
                    <CustomRadio
                      id="tt_tudong"
                      name="CauHinhTatToan_ThucHien"
                      value="tattoan_tudong"
                      checked={
                        data.CauHinhTatToan_ThucHien === "tattoan_tudong"
                      }
                      onChange={handleInputChange}
                      label="Tự động"
                      className="mb-0 mr-3"
                    />
                  )}
                  {CustomRadio && (
                    <CustomRadio
                      id="tt_thucong"
                      name="CauHinhTatToan_ThucHien"
                      value="tattoan_thucong"
                      checked={
                        data.CauHinhTatToan_ThucHien === "tattoan_thucong"
                      }
                      onChange={handleInputChange}
                      label="Thủ công"
                      className="mb-0"
                    />
                  )}
                </div>
                <div className="d-flex align-items-center mb-2">
                  <span>Thực hiện sau</span>
                  <input
                    type="number"
                    name="CauHinhTatToan_Ngay"
                    value={data.CauHinhTatToan_Ngay}
                    onChange={handleInputChange}
                    className="form-control input-sm mx-1"
                    style={{ width: "80px" }}
                    disabled={data.CauHinhTatToan_ThucHien !== "tattoan_tudong"}
                    data-type="number"
                  />
                  <span>Ngày</span>
                </div>
                <div className="d-flex align-items-center">
                  {CustomRadio && (
                    <CustomRadio
                      id="tt_xoavv"
                      name="CauHinhTatToan_Kieu"
                      value="tattoan_xoavinhvien"
                      checked={
                        data.CauHinhTatToan_Kieu === "tattoan_xoavinhvien"
                      }
                      onChange={handleInputChange}
                      label="Xóa HĐ đã tất toán vĩnh viễn"
                      className="mb-0 mr-3"
                    />
                  )}
                  {CustomRadio && (
                    <CustomRadio
                      id="tt_chuyenthu"
                      name="CauHinhTatToan_Kieu"
                      value="tattoan_chuyenthu"
                      checked={data.CauHinhTatToan_Kieu === "tattoan_chuyenthu"}
                      onChange={handleInputChange}
                      label="Chuyển HĐ đã tất toán"
                      className="mb-0"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
